import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { ApiService } from '../../services/api.service';
import { UiModeService } from '../../services/ui-mode.service';

@Component({
  selector: 'app-dish-v2',
  templateUrl: './dish-v2.component.html'
})
export class DishV2Component implements OnInit {
  public imageURL: string = 'https://keongkee.com.my/api/public/static';
  public defaultImage: string = 'https://keongkee.com.my/api/public/static/default.jpeg';

  shop: string;
  catId: string;
  subId: string;

  title = '';
  catName = '';
  items: Array<any> = [];

  loading = true;
  isSetapak = false;

  selectedDish: any = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private uiMode: UiModeService
  ) { }

  ngOnInit() {
    this.isSetapak = this.uiMode.shopFromHost() === 'setapak';

    this.route.queryParams.subscribe(params => {
      this.uiMode.scrollToTop();
      this.shop = params.shop || this.uiMode.shopFromHost();
      this.catId = params.cat;
      this.subId = params.sub;
      this.fetch();
    });
  }

  fetch() {
    this.loading = true;
    this.apiService.fetchMenu(this.shop).subscribe(
      (data: Array<any>) => {
        const cats = data || [];
        const category = cats.filter(c => c.id === this.catId)[0];

        this.catName = category ? category.name : '';

        let node = category;
        if (category && this.subId) {
          node = (category.subMenuPayloadList || []).filter(s => s.id === this.subId)[0];
        }

        if (node) {
          this.title = node.name;
          this.items = (node.dishPayloadList || []).filter(d => d.hide !== 'true');
        } else {
          this.title = '';
          this.items = [];
        }
        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  }

  hasFee(item): boolean {
    return !this.isSetapak && item.meta && item.meta.length > 0;
  }

  openFee(item) {
    if (this.hasFee(item)) {
      this.selectedDish = item;
    }
  }

  closeFee() {
    this.selectedDish = null;
  }

  back() {
    if (this.subId) {
      this.goCategoryPage();
    } else {
      this.goHome();
    }
  }

  goHome() {
    this.router.navigate(['/v2/menu'], { queryParams: { shop: this.shop } });
  }

  goCategoryPage() {
    this.router.navigate(['/v2/category'], { queryParams: { shop: this.shop, cat: this.catId } });
  }

  onImgError(event) {
    event.target.src = this.defaultImage;
  }
}
